import React from 'react'
import Title from '../../atoms/title/title'
import './areYouTeacher.scss'
import vello from '../../../assets/images/home/vello-crespo.svg'
import useMediaQuery from '../../../utils/useMediaQuery'
import { Link } from 'gatsby'

const AreYouTeacher = () => {
  const isMobile = useMediaQuery()
  return (
    <section className='f-section-are-you-teacher'>
      <div className='f-section-are-you-teacher__wrapper'>
        <div className='f-section-are-you-teacher__content'>
          {!isMobile && (
            <div className='f-section-are-you-teacher__content__img'>
              <img src={vello} />
            </div>
          )}
          <div className='f-section-are-you-teacher__content__description'>
            <Title txt={['¿Eres', 'un profesor/a?']} color='purple' />
            <p className='f-section-are-you-teacher__content__paragraph'>


              Puedes ingresar a todo nuestro contenido educativo sobre temas como la pubertad y la salud femenina, para
              compartir con tus estudiantes


            </p>
            <Link className='f-section-are-you-teacher__content__link' to='/aprende'>
              Ingresar al contenido educativo
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AreYouTeacher
